import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AuthApi } from "../../../api/AuthApi";
import { settingsApi } from "../../../api/settingsApi";
const initialState = {
  status: false,
  message: "",
  data: {},
  currentRequestId: undefined,
  loading: "idle",
  action: "",
  error: null,
};

export const hideUsername = createAsyncThunk(
  "settings/hideUsername",
  async (otp, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().settings;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await settingsApi.hideUsername(otp);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const showUsername = createAsyncThunk(
  "settings/showUsername",
  async (otp, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().settings;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await settingsApi.showUsername(otp);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const transferAllCoins = createAsyncThunk(
  "settings/transferAllCoins",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().settings;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await settingsApi.transferAllCoins(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteAccount = createAsyncThunk(
  "settings/deleteAccount",
  async (otp, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().settings;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await settingsApi.deleteAccount(otp);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const resetSettings = createAsyncThunk(
  "settings/resetSettings",
  async (settingsData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().settings;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = initialState;
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(hideUsername.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "hide_username";
        }
      })
      .addCase(hideUsername.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, hide_username: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(hideUsername.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.status = false;
          state.currentRequestId = undefined;
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
        }
      })
      .addCase(showUsername.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "show_username";
        }
      })
      .addCase(showUsername.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, show_username: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(showUsername.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.status = false;
          state.currentRequestId = undefined;
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
        }
      })
      .addCase(resetSettings.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "";
        }
      })
      .addCase(resetSettings.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = {};
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetSettings.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(transferAllCoins.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "transfer_all_coins";
        }
      })
      .addCase(transferAllCoins.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, transfer_all_coins: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(transferAllCoins.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.status = false;
          state.currentRequestId = undefined;
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
        }
      })
      .addCase(deleteAccount.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "delete_account";
        }
      })
      .addCase(deleteAccount.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, delete_account: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(deleteAccount.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.status = false;
          state.currentRequestId = undefined;
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
        }
      });
  },
});

export default settingsSlice.reducer;
